import { makeStyles } from '@mui/styles';
const priceInputStyles = makeStyles(() => ({
    errorWrapper: {},
    root: {},
    textField: {},
    input: {},
    inputRoot: {},
    inputFocused: {},
    label: {},
    helper: {},
    error: {},
    disabled: {},
    asterisk: {},
}), { name: 'PriceInput' });
export default priceInputStyles;
//# sourceMappingURL=priceInput.styles.js.map